import { US } from "@unauthenticated/catalog/locales/en/US";

import { catalog } from "./catalog";

export const CA = { ...US, catalog };
